// choices/endChoices.js
const endChoicesBg = [
  {
    label: "Открий цветовете си",
    value: "results",
  },
  {
    label: "Нека ги специализираме още повече",
    value: "large",
  },
];

export default endChoicesBg;
